import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { List, ListItem } from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import BrightnessLowTwoToneIcon from '@mui/icons-material/BrightnessLowTwoTone';
import {
  Search,
  SearchIconWrapper,
  StyledInputBase
} from './searchAppBarStyles';

interface SearchAppBarProps {
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  addData?: () => void;
  hide?: boolean;
  buttonText?: string;
  nav?: string;
  closeSidebar?: () => void;
  children?: React.ReactNode;
  sxButton?: object;
}

const SearchAppBar: React.FC<SearchAppBarProps> = ({
  handleChange,
  addData,
  hide = false,
  buttonText = 'Add',
  nav = '',
  closeSidebar,
  children,
  sxButton
}) => {
  return (
    <Box
      sx={{
        flexGrow: 0,
        boxShadow: '0',
        borderRadius: '8px',
        margin: '3vh 0 0 3px',
        backgroundColor: 'transparent',
      }}
    >
      <AppBar
        position="static"
        sx={{ background: 'transparent', boxShadow: '0' }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '5px'
          }}
        >
          <Search
            sx={{
              backdropFilter: 'blur(30px)',
              background: 'rgba(17, 25, 42, 0.9)',
              borderRadius: '18px',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
              color: 'white',
              '&:hover': {
                background: 'rgba(17, 25, 42, 0.7)'
              }
            }}
          >
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              onChange={handleChange}
              placeholder="Search…"
              inputProps={{ 'aria-label': 'search' }}
              sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
            />
          </Search>
          {!hide && (
            <Button
              variant="contained"
              color="primary"
              onClick={addData}
              sx={sxButton}
            >
              {buttonText}
            </Button>
          )}
          {nav && (
            <List component="div">
              <ListItem component="div">
                <Button
                  variant="contained"
                  color="primary"
                  // disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to={nav}
                >
                  {buttonText}
                </Button>
              </ListItem>
            </List>
          )}
        </Toolbar>
        {children}
      </AppBar>
    </Box>
  );
};

export default SearchAppBar;
